// Apariencia de los puestos del leaderboard: una sola fuente para el podio
// (ListUserTopPoints) y la lista (ListUserPoints), que antes repetían los
// mismos hex incrustados en las clases.

// La paleta de siempre: un evento que no configura nada se ve igual que antes.
export const DEFAULT_PLACE_COLORS = ['#FEC929', '#00B2FF', '#FFA800', '#9AA5B1', '#B8C1CC']

export const MAX_PODIUM_SIZE = 5
export const DEFAULT_PODIUM_SIZE = 3

export const podiumSize = (config) => {
  const size = parseInt(config && config.leaderboard_podium_size, 10)
  if (!size || size < 1) {
    return DEFAULT_PODIUM_SIZE
  }
  return Math.min(size, MAX_PODIUM_SIZE)
}

// Un color por puesto: lo configurado, y donde falte, el de la paleta de
// siempre. Así configurar solo el 1.º no deja sin color al resto.
export const placeColors = (config) => {
  const custom = (config && Array.isArray(config.leaderboard_place_colors) && config.leaderboard_place_colors) || []
  return DEFAULT_PLACE_COLORS.map((fallback, index) => custom[index] || fallback)
}

// Blanco o negro según cuál se lea mejor sobre el fondo (fórmula YIQ). Antes
// el texto era blanco fijo; con colores de marca libres, un amarillo claro lo
// dejaría ilegible. Ignora el canal alfa de los hex de 8 dígitos.
export const readableTextColor = (hex) => {
  const clean = String(hex || '').replace('#', '')
  if (clean.length < 6) {
    return '#FFFFFF'
  }
  const r = parseInt(clean.slice(0, 2), 16)
  const g = parseInt(clean.slice(2, 4), 16)
  const b = parseInt(clean.slice(4, 6), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 160 ? '#1F2937' : '#FFFFFF'
}

// Orden visual del podio: el 1.º al centro y los demás alternando a los
// lados. Devuelve índices de puesto (0 = 1.º). Con 5: [3, 1, 0, 2, 4].
export const podiumOrder = (size) => {
  const order = [0]
  for (let place = 1; place < size; place++) {
    if (place % 2 === 1) {
      order.unshift(place)
    } else {
      order.push(place)
    }
  }
  return order
}

// Color de texto por puesto. El contraste automático se aplica solo a los
// colores que configuró el cliente: la paleta de siempre conserva su texto
// blanco, para que un evento sin configurar se vea exactamente igual que antes.
export const placeTextColors = (config) => {
  const custom = (config && Array.isArray(config.leaderboard_place_colors) && config.leaderboard_place_colors) || []
  return DEFAULT_PLACE_COLORS.map((_, index) => (custom[index] ? readableTextColor(custom[index]) : '#FFFFFF'))
}
